import * as PropTypes from "prop-types"
import { useT } from "react-polyglot-hooks"
import styled from "styled-components"
import Typography from "components/styled/Typography"
import { Container, TitleWrapper } from "components/styled/Grid"
import { useCallback } from "react"
import useEmbla, { useEmblaArrows } from "hooks/useEmbla"
import Dots from "components/Slider/Dots"
import { Viewport } from "components/styled/SliderBase"
import { mq } from "helpers/styled"
import Arrow from "components/Slider/Arrow"
import Testimonial from "./Testimonial"

const Wrapper = styled.div`
  position: relative;
  margin: 0 -25px;
`

const ControlsContainer = styled.div`
  display: none;

  @media ${mq("lg")} {
    display: block;
  }
`

const Track = styled.div`
  display: flex;
  align-items: stretch;
  padding-bottom: 25px;
`

/**
 * @type import('embla-carousel').EmblaOptionsType
 */
const emblaOptions = { duration: 25, align: "start", containScroll: "trimSnaps" }

export default function Testimonials({ testimonials = {}, title }) {
  const safeTestimonials = testimonials && typeof testimonials === "object" ? testimonials : {}
  const keys = Object.keys(safeTestimonials)

  const breakpoints = [
    {
      size: "xl",
      slidesToScroll: 4,
      watchDrag: keys.length > 4
    },
    {
      size: "lg",
      slidesToScroll: 3,
      watchDrag: keys.length > 3
    }
  ]

  const t = useT()
  const { emblaRef, embla, selectedIndex, scrollSnaps } = useEmbla(emblaOptions, breakpoints)
  const { prevProps, nextProps } = useEmblaArrows(embla)

  const scrollTo = useCallback(index => embla && embla.scrollTo(index), [embla])

  if (keys.length < 4) return null

  return (
    <Container top={25} bottom={50}>
      <TitleWrapper>
        <Typography variant="title2" weight="medium" center space>
          {title || t("landings.testimonials.title")}
        </Typography>
      </TitleWrapper>
      <Wrapper>
        <ControlsContainer>
          <Arrow side="left" {...prevProps} />
          <Arrow side="right" {...nextProps} />
        </ControlsContainer>
        <Viewport ref={emblaRef}>
          <Track>
            {keys.map(key => (
              <Testimonial key={key} testimonial={safeTestimonials[key]} />
            ))}
          </Track>
        </Viewport>
        <Dots selectedIndex={selectedIndex} snaps={scrollSnaps} handleClick={scrollTo} />
      </Wrapper>
    </Container>
  )
}

Testimonials.propTypes = {
  testimonials: PropTypes.object,
  title: PropTypes.string
}

Testimonials.defaultProps = {
  testimonials: {},
  title: null
}
